import React from 'react'

export default function NationalDebt() {
  return (
    <div>NationalDebt</div>
  )
}
